import {Trans} from '@common/i18n/trans';

export function AiTextWarningMessage() {
  return (
    <Trans message="AI can make mistakes, so double-check that the results are accurate before using them." />
  );
}
